export default __webpack_public_path__ + "static/media/kick.990459f7.mp3";